var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#20242E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5188 28.8512L22.6556 24.2091L24.0982 22.9861L22.6557 21.7598L16.5189 17.1209C16.1245 16.8221 15.9566 16.3755 16.0782 15.9491C16.1998 15.5226 16.5926 15.1813 17.1086 15.0534C17.6245 14.9256 18.1853 15.0309 18.5796 15.3295L27.5201 22.0905C27.8263 22.322 28 22.6465 28 22.9861C28 23.3257 27.8263 23.6501 27.5201 23.8816L18.5796 30.6393C18.2906 30.8749 17.8957 31.0052 17.486 30.9998C17.0764 30.9947 16.6868 30.8546 16.4069 30.6118C16.1271 30.3689 15.9807 30.0443 16.002 29.7121C16.0231 29.38 16.2098 29.0692 16.5188 28.8512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.d0d17aa5a1d1f4b727f2116fa441959c.svg";
export { ForwardRef as ReactComponent };